<template>
  <div>
    <SectionTitle><span class="text-theme">4.</span> Payment</SectionTitle>
     <router-link :to="{name: 'accountPersonal'}">← Edit settings</router-link>
    <div class="row pt-3">
      <div class="col-12 col-lg-6">
        <PaymentSummary v-if="isAccountDataAvailable" />
        <PaymentWidget v-on:paid="completePayment" v-if="price > 0" />
        <button class="btn btn-theme btn-lg w-100" v-else v-on:click="completePayment">
          <span>{{ $t('payment.getForFree') }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import PaymentWidget from '../components/Payment/PaymentWidget'
import PaymentSummary from '../components/Payment/PaymentSummary'
import SectionTitle from '../components/elements/SectionTitle'

export default {
  components: {
    PaymentWidget,
    PaymentSummary,
    SectionTitle
  },
  computed: {
    ...mapState('personal', ['accounts']),
    ...mapGetters('personal', ['selectedAccountsData']),
    ...mapGetters('payment', ['price']),
    isAccountDataAvailable() {
      return this.selectedAccountsData && this.selectedAccountsData[0] && this.selectedAccountsData[0] !== null
    }
  },
  mounted() {
    if (this.accounts.length) {
      return
    }
    this.accountsRequest()
  },
  methods: {
    ...mapActions('personal', ['accountsRequest']),
    completePayment() {
      this.$router.push({ name: 'accountDone' })
    }
  }
}
</script>
